import { useQuery } from '@tanstack/react-query';
import { api, type AgentProfile } from '@/lib/api';

export function useSuggestions(limit = 3) {
  return useQuery({
    queryKey: ['suggestions', limit],
    queryFn: async () => {
      const response = await api.get<AgentProfile[]>(`/suggestions/agents?limit=${limit}`);
      if (!response.success) throw new Error(response.error?.message || 'Failed to load suggestions');
      return response.data || [];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
